module.exports = __webpack_public_path__ + "img/special3.0965f8ec.png";